import React, { useEffect, useState } from 'react';
import posthog from 'posthog-js';
import { initiateCheckout } from './utils/checkout';
import './Checkout.css';

const Checkout: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const startCheckout = async () => {
      try {
        setIsLoading(true);
        await initiateCheckout();
      } catch (error) {
        console.error('Checkout failed:', error);
        posthog.capture('checkout_failed');
        posthog.captureException(error);
        // Redirect to home on error
        window.location.href = '/';
      }
    };

    startCheckout();
  }, []);

  return (
    <div className="checkout-page">
      <div className="checkout-container">
        {isLoading && (
          <div className="checkout-loading">
            <div className="spinner"></div>
            <p>Starting checkout...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Checkout;

